import React from "react";

function Fax() {
  return <h2>Fax Us</h2>;
}

export default Fax;
